import { render } from "./StaticPageChrome.vue?vue&type=template&id=5761474a"
import script from "./StaticPageChrome.vue?vue&type=script&lang=js"
export * from "./StaticPageChrome.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./StaticPageChrome.vue?vue&type=style&index=0&id=5761474a&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__